import { RegistrationConfirmation } from './types/details'

/**
 * DO-13065: "let in, but the address is not verified yet". This is the state that shows the amber
 * header bar, the notification CTA and the send-mail block.
 *
 * Deliberately narrower than `!hasConfirmedEmail`: an unconfirmed user who is NOT deferred is handled
 * by the blocking `confirmEmail` gate (see getOnboardingGate.ts) and needs none of the soft hints.
 * While the `GET /user/confirmed` payload is still missing nothing is pending — no flash of the bar
 * before the API has answered.
 */
export const isEmailConfirmationPending = (confirmation?: Partial<RegistrationConfirmation> | null): boolean => {
  if (!confirmation) return false
  return confirmation.hasConfirmedEmail === false && confirmation.emailConfirmationDeferred === true
}
